import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "../../../investor/investor.css";
import { TileLayout } from "@progress/kendo-react-layout";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBAEditor } from '../../../UiComponents/SBAEditor';
import { SBADropDown, SBAMultiSelect } from "../../../UiComponents/SBADropDown";
import { 
    getClientProfileDocuments, 
    DownloadDocument, 
    getClientProfileTracker, 
    getClientProfileNotes, 
    getClientProfileGetTasks,
    getAllFamilies,
    getPortfoliosByFamily
} from "../../../../config/apiConfig";
import RecommendationsWid from "./RecommendationsWid";
export const ClientProfile = (props) => {
  const locationData = useLocation();
  const dispatch = useDispatch();
    const params = useParams();
    const Gstate = useSelector((state) => { return state;}) || {};
    const [Taskdata, setTaskdata] = useState([]);
    const [Documentdata, setDocumentdata] = useState([]);
    const [Notesdata, setNotesdata] = useState([]); 
    const [InvestorTrackingList, setInvestorTrackingList] = useState([]);
    const [selectedInvestorTracking, setSelectedInvestorTracking] = useState('Approved');
    const [showModal, setShowModal] = useState(false);
    const [comments, setcomments] = useState();
    const [summarycomments, setsummarycomments] = useState();
    const [selectedRecButton, setSelectedRecButton] = useState(0);
    const [familiesList, setFamiliesList] = useState([]);
    const [selectedFamily, setSelectedFamily] = useState({});
    const [selectedPortfolio, setSelectedPortfolio] = useState([]);

    const biographicalInfo = Gstate?.Contacts.ContactInfo?.ContactInfo?.BiographicalInfo || "";
    const [portfolioList, setPortfolioList] = useState([]);


    const [Title, setTitle] = useState();
    const [summarybuttonActive, setSummarybuttonActive] = useState(true);
    const [recentbuttonActive, setRecentbuttonActive] = useState(false);
    const taskRef = useRef();
    const notesRef = useRef();
    useEffect(() => {       
        getInvestorTrackingList(params.ContactId,null);
        ClientProfileDocuments(params.ContactId);
        ClientProfileNotes(params.ContactId, 1);
        ClientProfileGetTasks(params.ContactId);
        fetchFamilyByContactId();
    }, []);

    useEffect(() => {
        if (selectedFamily.FamilyId !== 0) {
            fetchPortfoliosByFamily();
        }
    }, [selectedFamily]);
    const fetchFamilyByContactId = async() => {
        try {
            const list = await sbaAxios({
                url:getAllFamilies
            });
            setFamiliesList(list);
            setSelectedFamily(list[1]);
        } catch (error) {
            setFamiliesList([]);
            setSelectedFamily({});
        }
    };

    const fetchPortfoliosByFamily = async () => {
        try {
            const list = await sbaAxios({
                url: getPortfoliosByFamily,
                params: {
                    familyId: selectedFamily.FamilyId
                }
            });
            setPortfolioList(list);
            setSelectedPortfolio(list);
        }
        catch (e) {
            setPortfolioList([]);
            setSelectedPortfolio([]);
        }
    };
    const ClientProfileDocuments = async (contactid) => {

        const response = await sbaAxios({
            url: `${getClientProfileDocuments}${contactid}`,
            method: 'get',
        });
        setDocumentdata(response);
    }
    const ClientProfileNotes = async (contactid, typeid) => {
        
        const response = await sbaAxios({
            url: `${getClientProfileNotes}${contactid},${typeid}`,
            method: 'get',
        });
        if (response) {
            setNotesdata(response)
           // setsummarycomments(response[0].NoteBodyHtml)
        }
        else {
            setNotesdata([])
        }
    }
    const ClientProfileGetTasks = async (contactid) => {
        const response = await sbaAxios({
            url: `${getClientProfileGetTasks}${contactid}`,
            method: 'get',
        });
        if (response) {
            setTaskdata(response);
        } else {
            setTaskdata([])
        }
    }
    const getInvestorTrackingList = (contactId, StatusId) => {
        sbaAxios({
            url: `${getClientProfileTracker}${contactId},${StatusId}`,
            method: 'get',
        })
            .then((repos) => {

                setInvestorTrackingList(repos)
            })
            .catch((error) => {

                return (error);
            });
    };
    // Button change code
    const buttonclk = (data) => {

        if (typeof data !== "undefined") {
            setSelectedInvestorTracking(val=>data);
            if (data === "Proposed") {
                getInvestorTrackingList(params.ContactId,2)
            }
            else if (data === "Approved") {
                getInvestorTrackingList(params.ContactId, 9)
            }
            else if (data === "Rejected") {
                getInvestorTrackingList(params.ContactId, 10)
            }
        }
    }
    const commentsChange = (event) => {
        setcomments(event.html);
    }
    const closeModal = () => {
        setShowModal(false);
    }
    // PDf open 
    const pdfview = (documentId, documentExtension, documentName) => {
        try {
            if (documentExtension === ".pdf") {

                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,
                    //     responseType: 'blob'
                }).then((response) => {
                    window.open(urls);

                });

            }
        } catch (error) {
            console.error("Error opening document:", error);
        }
    };
    //Grid Functions
    const getDateFormatted = (params) => {
        const isoDate = params.value;
        const formattedDate = moment(isoDate).format("MM-DD-YYYY");
        return formattedDate;
    };
    const documentRenderer = (event) => {
        const handleClick = () => {         
            pdfview(event.data.DocumentId, event.data.DocumentExtension, event.data.DocumentName);
        };

        return (
            <div className="col-1 text-sm-end fw-medium">
                <span className="SBA_hand">
                    <i
                        className="fas fa-file-pdf"
                        style={{ color: "#F40F02" }}
                        onClick={handleClick}
                    ></i>
                </span>
            </div>
        );
    };
    
    var taskdefs = [
        
        {
            field: "TaskName",
            headerName: "Task Name",

        },
        {
            field: "DueDate",
            headerName: "Due Date",
            valueFormatter: getDateFormatted

        },
        {
            field: "Owner",
            headerName: "Owner",

        },
        {
            field: "TaskType",
            headerName: "Task Type",

        },
        
    ];
    var docdefs = [
        {
            field: "EntityName",
            headerName: "EntityName",
        },
        {
            field: "DocumentName",
            headerName: "Document Name",

        },
        
        {
            field: "DocumentDate",
            headerName: "Document Date",
            valueFormatter: getDateFormatted

        },
        {
            field: "DocumentExtension",
            headerName: "Document Extension",
            cellRenderer: documentRenderer
        },

    ];
    var notesdefs = [
        {
            field: "ContactAccountName",
            headerName: "Contact/ AccountName",
        },
        {
            field: "NoteBody",
            headerName: "Body",

        },
        
        {
            field: "NoteSubject",
            headerName: "Subject",

        },
        {
            field: "NoteDate",
            headerName: "Note Date",
            valueFormatter: getDateFormatted
        },
        {
            field: "NoteBodyHtml",
            headerName: "Note Body Html",

        },
        {
            field: "NoteOwner",
            headerName: "Note Owner",
           

        },

    ];
    const addpopup = (data, name) => {   
        setShowModal(true);
        if (name == 'Note') {
            setTitle('Notes Description');
          setcomments(data.NoteBody)
        } else if (name == 'Task') {
            setTitle('Task Description');
          setcomments(data.TaskName)
        } else if(name=="InvestorTracking")
        {
            setTitle('Notes');
            setcomments(data.Notes)
          
        }
    }
    const defaultColDef = {
        sortable: true, filter: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter',resizable:true
    }

    const SummaryValue = () => {
       
        setSummarybuttonActive(true);
        setRecentbuttonActive(false);
       
    }

    const RecentValue = () => {   
        setSummarybuttonActive(false);
        setRecentbuttonActive(true);
       
    }

  useEffect(() => {
      document.title = `Client Profile`;  
  }, []);

  const handleSelectedPortfolio = (e) => {
    setSelectedPortfolio(e.value);
};

  const recommendButtons = ["Approved", "Proposed", "Rejected"];
  const recButtonClick = (index) => {
    setSelectedRecButton(index);
  }

  const RecButtonRenderer = ({selectedIndex}) => {
    return(
        <>
        <div className="header-container">
          <b>Recommendation (Last 12 months)</b>
          <div className="col-md-3">
          <label className="label">Family</label>
            <div>
                <SBADropDown
                className="w-75"
                textField={"FamilyName"}
                valueField={"FamilyId"}
                data={familiesList}
                value={selectedFamily}
                disabled={true}
                //  onChange={(e)=> }
                >
                </SBADropDown>
            </div>
          </div>
          <div className='col-md-3' >
            <label className='label'>Portfolio</label>
                <div>
                    <SBAMultiSelect
                        className="w-100"
                        data={portfolioList}
                        textField={"EntityName"}
                        valueField={"EntityId"}
                        value={selectedPortfolio}
                        onChange={handleSelectedPortfolio}
                        popupSettings={{ className: "modalDD" }}
                    ></SBAMultiSelect>
                </div>
         </div>
          <div className="button-container" style={{top:'10px'}}>
            {recommendButtons.map((name,index) => (
              <button
                key={index}
                className={selectedIndex === index? "selected-non-gappable-button p-2": "non gappable-button p-2"}
                onClick={() => recButtonClick(index)}
                >
                  {name}
                </button>
            ))}
          </div>
        </div>
        </>
      )
  };
//   header: <div className="customHeaderSection"></div>,
{/* <RecButtonRenderer selectedIndex={selectedRecButton} />, */}
//       body: <RecentActivities bIndex={raButton}></RecentActivities>,
const [data, setData] = useState([
    { col: 1, colSpan: 2, rowSpan: 2 },
    { col: 3, colSpan: 2, rowSpan: 2 },
    { col: 1, colSpan: 2, rowSpan: 2 },
    { col: 3, colSpan: 2, rowSpan: 2 },
    { col: 1, colSpan: 2, rowSpan: 2 },
    { col: 3, colSpan: 2, rowSpan: 2 },
    { col: 1, colSpan: 2, rowSpan: 1 },
    { col: 3, colSpan: 2, rowSpan: 1 },
    { col: 1, colSpan: 2, rowSpan: 1 }
  ]);
  const widgetItems=[
    {
        header: <div className="customHeaderSection"></div>,
        body: <RecommendationsWid data={[]} family={selectedFamily} familiesList={familiesList}portfolioList={portfolioList}/>
    },
    {
        header: 'Biographical Info',
        body:
            <div className="p-4">
                {biographicalInfo}
            </div>
    },
    {
        header: 'Notes (Last 12 months)',
        body:
            <div>
                <div className="ag-theme-alpine m-1 " style={{ height: 330 }}>
                    <AgGridReact
                        columnDefs={notesdefs}
                        rowData={Notesdata}
                        defaultColDef={defaultColDef}
                        enableBrowserTooltips={true}
                        tooltipInteraction={true}
                        rowSelection="single"
                        onRowDoubleClicked={(e) => { addpopup(e.data, 'Note') }}
                        ref={notesRef}
                    />


                </div>
            </div>
    },
    {
        header: 'Presentation (Last 12 months)',
        body:
            <div>

                <div className="ag-theme-alpine m-1 " style={{ height: 330 }}>
                    <AgGridReact
                        columnDefs={docdefs}
                        rowData={Documentdata}
                        defaultColDef={defaultColDef}
                        enableBrowserTooltips={true}
                        tooltipInteraction={true}

                    />
                </div>

            </div>
    },
    {
        header: 'Tasks (Last 12 months)',
        body:
            <div>
                <div className="ag-theme-alpine m-1 " style={{ height: 330 }}>
                    <AgGridReact
                        ref={taskRef}
                        columnDefs={taskdefs}
                        rowData={Taskdata}
                        defaultColDef={defaultColDef}
                        enableBrowserTooltips={true}
                        tooltipInteraction={true}
                        rowSelection="single"
                        onRowDoubleClicked={(e) => { addpopup(e.data, 'Task') }}

                    />
                </div>

            </div>
    }
];
    //    setWidgetItems(val=>[[
    //     {
    //         header: <div className="customHeaderSection"></div>,
    //         body: <RecommendationsWid data={[]} family={selectedFamily} familiesList={familiesList}portfolioList={portfolioList}/>
    //     },
    //     {
    //         header: 'Notes (Last 12 months)',
    //         body:
    //             <div>
    //                 <div className="ag-theme-alpine m-1 " style={{ height: 330 }}>
    //                     <AgGridReact
    //                         columnDefs={notesdefs}
    //                         rowData={Notesdata}
    //                         defaultColDef={defaultColDef}
    //                         enableBrowserTooltips={true}
    //                         tooltipInteraction={true}
    //                         rowSelection="single"
    //                         onRowDoubleClicked={(e) => { addpopup(e.data, 'Note') }}
    //                         ref={notesRef}
    //                     />
    
    
    //                 </div>
    //             </div>
    //     },
    //     {
    //         header: 'Presentation (Last 12 months)',
    //         body:
    //             <div>
    
    //                 <div className="ag-theme-alpine m-1 " style={{ height: 330 }}>
    //                     <AgGridReact
    //                         columnDefs={docdefs}
    //                         rowData={Documentdata}
    //                         defaultColDef={defaultColDef}
    //                         enableBrowserTooltips={true}
    //                         tooltipInteraction={true}
    
    //                     />
    //                 </div>
    
    //             </div>
    //     },
    //     {
    //         header: 'Tasks (Last 12 months)',
    //         body:
    //             <div>
    //                 <div className="ag-theme-alpine m-1 " style={{ height: 330 }}>
    //                     <AgGridReact
    //                         ref={taskRef}
    //                         columnDefs={taskdefs}
    //                         rowData={Taskdata}
    //                         defaultColDef={defaultColDef}
    //                         enableBrowserTooltips={true}
    //                         tooltipInteraction={true}
    //                         rowSelection="single"
    //                         onRowDoubleClicked={(e) => { addpopup(e.data, 'Task') }}
    
    //                     />
    //                 </div>
    
    //             </div>
    //     }
    // ]])
    // }, [selectedFamily]);
    return (
            <>                    
              <div className="bg-white m-3 mb-3 p-3 border rounded">             
              
              <div class="widgets py-3">
                  <div class="row" id="assettile" >
                      
                      <TileLayout
                        columns={4} 
                        rowHeight={200} 
                        positions={data}
                        gap={{
                          rows: 10,
                          columns: 10
                        }}
                          items={widgetItems}
                      />
                  </div>
                  {/* <div class="row" id="assettile" >
                      <TileLayout
                          columns={2}
                          rowHeight={450}
                          gap={{ rows: 20, columns: 30 }}
                          items={items2}
                      />
                  </div> */}
              </div>
              {<Modal show={showModal}>
                  <Modal.Header closeButton onClick={closeModal}>
                      <Modal.Title>{Title}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                      <SBAEditor id="editor" onChange={commentsChange} defaultContent={comments} editorHeight={300} setContent={setcomments}  ></SBAEditor>
                  </Modal.Body>
                  <Modal.Footer>
                      <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                      
                  </Modal.Footer>
              </Modal>}
          </div>       
    </>
  );
};
